import React from 'react';
import s from './popover.module.css';

// The popover's action row. Email family, Message and Duplicate are drawn
// disabled, with a title saying so, because a missing button is harder to
// understand than a greyed-out one.

const GLYPH = {
  edit: <path d="M9.5 2.5l2 2L5 11l-2.5.5L3 9l6.5-6.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />,
  email: <><rect x="1.5" y="3" width="11" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.3" /><path d="M2 4l5 3.5L12 4" stroke="currentColor" strokeWidth="1.3" /></>,
  message: <path d="M2 3.5h10v6H7l-3 2.5V9.5H2v-6z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />,
  duplicate: <><rect x="2" y="2" width="7" height="7" rx="1.2" stroke="currentColor" strokeWidth="1.3" /><rect x="5" y="5" width="7" height="7" rx="1.2" stroke="currentColor" strokeWidth="1.3" /></>,
  trash: <path d="M3 4h8M5.5 4V2.8h3V4M4 4l.6 7.2h4.8L10 4" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />,
  close: <path d="M3.5 3.5l7 7M10.5 3.5l-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />,
};

function IconButton({ glyph, label, onClick, disabled }) {
  return (
    <button
      className={s.iconButton}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={disabled ? `${label} — not available yet` : label}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">{GLYPH[glyph]}</svg>
    </button>
  );
}

export default function PopoverToolbar({ onEdit, onDelete, onClose }) {
  return (
    <div className={s.toolbar}>
      <IconButton glyph="edit" label="Edit" onClick={onEdit} />
      <IconButton glyph="email" label="Email family" disabled />
      <IconButton glyph="message" label="Message" disabled />
      <IconButton glyph="duplicate" label="Duplicate" disabled />
      <IconButton glyph="trash" label="Delete" onClick={onDelete} />
      <span className={s.spacer} />
      <IconButton glyph="close" label="Close" onClick={onClose} />
    </div>
  );
}
